import { cacheTypes, getMethodByCallBack, getMethodByDispatcher, postMethodByCallBack, postMethodByDispatcher, setErrorDialog } from "../../../store/api/CommonFunctions";

export function getStaffLastCode(onGetCode) {
    getMethodByCallBack(`api/StaffAPI/GetStaffLastCode`, cacheTypes.NoCache, onGetCode, "GetStaffLastCode");
}
export function addOrUpdateStaff(data, onPost) {
    postMethodByCallBack(`api/StaffAPI/AddOrUpdateStaff`, data, onPost, "AddOrUpdateStaff")
}
export function getStaff(id, onGet) {
    getMethodByCallBack(`api/StaffAPI/GetStaffByID?Id=${id}`, cacheTypes.NoCache, onGet, "GetStaffByID");
}
export function getStaffAttachments(staffID) {
    return dispatch => dispatch(getMethodByDispatcher(`api/Attachments/GetAttachmentList?parentID=${staffID}&attachmentType=Staff`, "GET_STAFF_ATTACHMENTS", cacheTypes.NoCache, "دریافت پیوست ها"));
}
export function getStaffAutoSendData(staffID, onGet) {
    getMethodByCallBack(`api/StaffAPI/GetStaffAutoSendData?staffID=${staffID}`, cacheTypes.NoCache, onGet, "GetStaffAutoSendData")
}
export function updateStaffAutoSendData(data, onUpdate) {
    postMethodByCallBack(`api/StaffAPI/UpdateStaffAutoSendData`, data, onUpdate, "UpdateStaffAutoSendData");
}
export function searchStaff(data, onSearch) {
    return dispatch => {
        dispatch({
            type: "STAFF_SEARCH_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher("api/StaffAPI/SearchStaff", data, "SEARCH_STAFF", "جستجوی نماینده/تکنسین", onSearch));
    }
}
/**
 * 
 * @param {object} data 
 * @param {function} onGet 
 */
export function getStaffMobilesByFilter(data, onGet)
{
    postMethodByCallBack("api/StaffAPI/GetStaffMobilesByFilter", data, onGet, "GET_STAFF_MOBILES");
}
export function deleteStaff(id, onDelete) {
    return dispatch => {
        const onSuccess=(res)=>{
            if(!res.Error && res !=="PENDING")
            {
                setErrorDialog(dispatch,"success","حذف تکنسین/نماینده");
                onDelete(res);
            }
            else if(res.Error)
            {
                setErrorDialog(dispatch, res.Error,"حذف تکنسین/نماینده");
            }           
        }
        getMethodByCallBack(`api/StaffAPI/DeleteStaff?Id=${id}`, cacheTypes.NoCache, onSuccess, "DeleteStaff");
    }
}
export function getAddressList(id, onGet)
{
    getMethodByCallBack(`api/StaffAPI/GetAddressList?id=${id}`,cacheTypes.NoCache, onGet,"GetAddressList");
}